// @services/clients/FeedbackClient.ts
import type { FeedbackClient as InteropFeedbackClient } from '@ps-bridge/clients/feedback';
import type { FeedbackError, SubmitFeedbackRequest, SubmitFeedbackResponse } from '@ps-bridge/models/core/dataContracts';
import type { TaskEitherTs } from '@ps-bridge/interop';
import { taskEitherFromRaw } from '@utils/effects/branded';

export interface FeedbackClient {
    readonly submitFeedback: (
        request: SubmitFeedbackRequest,
    ) => TaskEitherTs<FeedbackError, SubmitFeedbackResponse>;
}

export const fromInteropFeedbackClient = (client: InteropFeedbackClient): FeedbackClient => ({
    submitFeedback: (request) => taskEitherFromRaw(client.submitFeedback(request)),
});
